<div class="modal confirm-modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1>{{ 'COMMON.CONFIRM_DELETION' | translate }}</h1>
      </div>
      <div class="modal-body">
        <p>{{ 'COMMON.DELETE_CONFIRMATION_MESSAGE' | translate }}</p>
        @if (warningMessages.length > 0) {
        <div class="alert alert-warning d-flex align-items-center">
         <i class="bi bi-exclamation-triangle-fill me-2 "></i>
          <div>
            
            @for (warning of warningMessages; track $index) {
             <p class="mb-0"> {{ warning }}  </p>
            }
            
          </div>
        </div>
        }
        <button #yesButton class="btn btn-primary me-2" (click)="onConfirm()">
          {{ 'COMMON.YES' | translate }}
        </button>
        <button class="btn btn-secondary ml-2" (click)="onCancel()">
          {{ 'COMMON.NO' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
